<template lang="html">
  <div class="sidebar noselect">

    <div class="account" @blur="showAccOpts(false);" ref="account" :class="{'expanded-account-options':menuStatus.accountOptsOpen}">
      <div class="account-info" @click="showAccOpts()">
        <div class="account-img" :style="'background: url('+$root.data.user.picture+'), url(/img/error.png)'"></div>
        <div class="account-label">
          {{$root.data.user.name}}
          <div v-if="!menuStatus.accountOptsOpen" class="fas fa-caret-down"></div>
          <div v-else class="fas fa-caret-up"></div>
        </div>
      </div>
      <div class="account-options">
        <div class="menu-item" @click="go('account')">
          <i class="fas fa-user-circle"></i>
          <span>Account</span>
        </div>
        <!-- <div class="menu-item" @click="logout()">
          <i class="fas fa-sign-out-alt"></i>
          <span>Logout</span>
        </div> -->
      </div>
    </div>

    <div class="menu">
      <div class="menu-item" @click="go('compose')" :class="[menuStatus.compose]">
        <i class="fas fa-plus"></i>
        <span>New Entry</span>
      </div>

      <div class="menu-spacer"></div>

      <div class="menu-item" @click="go('list')" :class="[menuStatus.list]">
        <i class="fas fa-bars"></i>
        <span>List</span>
      </div>
      <div class="menu-item" @click="go('month')" :class="[menuStatus.month]">
        <i class="far fa-calendar-alt"></i>
        <span>Month</span>
      </div>
      <div class="menu-item" @click="go('map')" :class="[menuStatus.map]">
        <i class="fas fa-map-marked-alt"></i>
        <span>Map</span>
      </div>
      <div class="menu-spacer"></div>
      <div class="menu-item" @click="go('services')" :class="[menuStatus.services]">
        <!-- <i class="fas fa-external-link-square-alt"></i> -->
        <i class="fas fa-sync"></i>
        <span>Services</span>
      </div>
      <div class="menu-item" @click="go('settings')" :class="{'active-menu':$router.currentRoute.name == 'settings'}">
        <i class="fas fa-sliders-h"></i>
        <span>Settings</span>
      </div>
      <div class="footer-spacer"></div>
      <div class="footer">
        Copyright © 2019 <a target='_blank' href="https://bencarroll.tech">Ben Carroll</a>
      </div>
    </div>
</div>
</template>

<script>
export default {
  name: 'Sidebar',
  data: function() {
    return {
      menuStatus: {
        compose: '',
        list: '',
        month: '',
        map: '',
        services: '',
        settings: '',
        accountOptsOpen: false
      }
    }
  },
  watch: {
    $route: function() {
      this.updateClasses();
    }
  },
  mounted: function() {
    this.updateClasses();
  },
  methods: {
    go(page) {
      this.$router.push({
        name: page
      })
      this.$emit('hide');
    },
    updateClasses() {
      var route = this.$router.currentRoute.name
      for (var item in this.menuStatus)
        if (this.menuStatus.hasOwnProperty(item)) {
          if (route != item) {
            this.menuStatus[item] = ''
          } else {
            this.menuStatus[item] = 'active-menu'
          }
        }
    },
    logout() {
      window.sessionStorage.setItem('loggedIn', '')
      this.$parent.checkLogin();
    },
    showAccOpts(val) {
      if (val == undefined) {
        val = !this.menuStatus.accountOptsOpen
      }
      if (val == true) {
        this.$refs.account.focus()
      }
      this.menuStatus.accountOptsOpen = val;
    }
  }
}
</script>

<style lang="css" scoped>
.sidebar {
  background: var(--shade3);
  color: var(--light);
  height: 100%;
  overflow-y: auto;
  position: relative;
  z-index: 8;
}
.listview-panes.focus-view ~ .sidebar {
  box-shadow: 0px 0px 20px 10px rgba(0, 0, 0, .5);
}

.account {
  padding-top: 50px;
  text-align: center;
  cursor: pointer;
}

.account-img {
  display: block;
  border-radius: 15%;
  height: 100px;
  width: 100px;
  margin: 0 auto;
  background-size: cover !important;
}
.account-label {
  display: block;
  margin-top: 15px;
  font-size: large;
  font-weight: bold;
}

.account-options {
  margin-bottom: 30px;
  padding-top: 10px;
  text-align: left;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.2s ease-out;
}

.expanded-account-options .account-options {
  max-height: 88px;
  transition: max-height 0.25s ease-in;
}
/* .label-spacer {
  display: inline-block;
  width: 5px;
  content: '\00A0';
} */
.menu {
  height: calc(100% - 232px);
  transition: height 0.2s ease-in-out;
  position: relative;
}
.expanded-account-options + .menu {
  height: calc(100% - 276px);/*320px);*/
  transition: height 0.25s ease-in-out;
}
.menu-item {
  display: block;
  background: var(--shade2);
  height: 24px;
  padding: 10px;
  cursor: pointer;
  transition: background .5s;
}
.menu-item:hover:not(.active-menu) {
  background: var(--shade1) !important;
  transition: background .1s;
}
.menu-item > i {
  padding: 0 10px 0 5px;
  width: 20px;
  text-align: center;
}

.menu-spacer {
  height: 20px;
}
.active-menu {
  background: #4e6d97 !important; /* Lightened version of var(--shade1); */
}

.footer-spacer {
  height: calc(100% - 336px);
}
.footer {
  background: var(--shade3);
  text-align: center;
  width: 100%;
  bottom: 0;
  left: 0;
  color: #808080;
}
.footer > a {
  color: #ff8c00;
}
</style>
